import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import SendPanelWithRequestNoteWidget from '../../../widgets/sendPanelWithRequestNoteWidget/SendPanelWithRequestNoteWidget'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getSignContract } from '../../../redux/actions/contract'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'
import ContractSigningWidgets from '../../../widgets/ContractSigning/ContractSigningWidgets'
import { Link } from 'react-router-dom'

export default function ManagerOfferAuthorizedSignatory() {
  //ขั้นที่ 3 ลงนามสัญญา/ข้อตกลง
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getSignContract(projectVersionId)
      setSchema(response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal statusDefault={8}>
        <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />

        {schema?.forms?.agreementDetails && (
          <AgreementAdditionalWidgets
            showCommandButton={true}
            formSchema={schema.forms.agreementDetails}
          />
        )}

        {schema?.forms?.contractorList && (
          <ContractSigningWidgets schema={schema.forms.contractorList} />
        )}

        {/* {schema?.forms?.requestNote?.note && (
          <SendPanelWithRequestNoteWidget
            showCommandButton={!schema.forms.requestNote.disabled}
            schema={schema?.forms?.requestNote}
            isManagerApprove={true}
          />
        )} */}

        <Panel
          header={schema?.header}
          collapsible
          defaultExpanded
          bordered
          shaded
          style={{ marginBottom: 10 }}
        >
          <Link onClick={() => window.open(`${process.env.REACT_APP_ESIGNATURE_URL}`)}>
            ไปยังระบบลงลายมือชื่ออิเล็กทรอนิกส์ (e-Signature)
          </Link>
          <br />
        </Panel>
        <br />
        <br />
      </SidebarProposal>
    </>
  )
}
